import React from 'react';
import styles from './Button.module.css';

const Button = React.forwardRef(({
        children,
        variant = 'primary',
        size = 'medium',
        as: Component = 'button',
        className = '',
        loading = false,
        disabled = false,
        ...props
    }, ref) => {
    const classNames = [
        styles.button,
        styles[variant],
        styles[size],
        loading && styles.loading,
        className
    ].filter(Boolean).join(' ');

    return (
        <Component
        ref={ref}
        className={classNames}
        disabled={disabled || loading}
        {...props}
        >
        {loading && <span className={styles.spinner}>⏳</span>}
        {children}
        </Component>
    );
});

Button.displayName = 'Button';

export default Button;